import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
// import esLocale from '@fullcalendar/core/locales/es';
// import frLocale from '@fullcalendar/core/locales/fr';
import { Box } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { getSessionData } from '../../../Utils/apiServices';
import KenPopover from '../../../Components/KenPopOver';
import { fade, makeStyles } from '@material-ui/core/styles';
import { AiOutlineClockCircle } from 'react-icons/ai';
import { BiVideoRecording } from 'react-icons/bi';

import { SiCoursera } from 'react-icons/si';
import { GiTeacher } from 'react-icons/gi';
import { FaChalkboardTeacher } from 'react-icons/fa';

import { Button } from 'rsuite';
import './TimeTable.css';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  popover: {
    width: '320px',
    padding: '8px 0 0 10px',
  },
}));

const TimeTableNew = () => {
  const [state, setState] = React.useState({
    weekendsVisible: true,
    currentEvents: [],
  });
  const [eventData, setEventData] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [courseName, setCourseName] = React.useState('');
  const [sessionName, setSessionName] = React.useState('');
  const [facultyName, setFacultyName] = React.useState('');
  const [faciltyName, setFacilityName] = React.useState('');
  const [startTime, setStartTime] = React.useState('');
  const [endTime, setEndTime] = React.useState('');

  const classes = useStyles();
  const open = Boolean(anchorEl);
  const id = open ? 'apps-popover' : undefined;

  useEffect(async () => {
    const userData = JSON.parse(localStorage.getItem('userDetails'));
    const contactId = userData.ContactId;
    const sessionData = await getSessionData(contactId ? contactId : '');
    const dataSession = Object.values(sessionData);
    const newEvents = [...dataSession];
    console.log('newEvents====================>', newEvents);
    const transformed = newEvents.map(
      ({
        sessionName,
        endDate,
        contactId,
        contactName,
        FacultyBooking,
        courseId,
        courseName,
        courseOfferingId,
        facultyName,
        id,
        startDate,
        termId,
      }) => ({
        title: `${courseName} - ${sessionName}`,
        end: `${endDate.split(' ').join('T')}`,
        contactId: contactId,
        contactName,
        startTimes: startDate.split(' ')[1],
        endTimes: endDate.split(' ')[1],
        sessionName,
        FacultyBooking,
        courseId,
        courseName,
        courseOfferingId,
        facultyName,
        termId,
        id,
        start: `${startDate.split(' ').join('T')}`, // `${endDate}T00:00:00`
      })
    );
    console.log('teeeeeeeeeeeeeeeeeee', transformed);
    const newDataEventUnAssiged = transformed.map((ele) => {
      return {
        ...ele,
        editable: true,
        allDay: false,
        // fontSize: '14px',
        // padding: '8px',
        textColor: '##272727 ',
        // backgroundColor: '#dee1ec',
        // border: 'none',
        borderLeft: '3px solid ##272727 ',
        boxShadow: 'none',
        fontWeight: 700,
      };
    });
    setEventData(newDataEventUnAssiged);
  }, []);

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const changeDateFormat = (date) => {
    const rightDate = new Date('1970-01-01T' + date + 'Z').toLocaleTimeString(
      'en-US',
      {
        timeZone: 'UTC',
        hour12: true,
        hour: 'numeric',
        minute: 'numeric',
      }
    );
    return rightDate;
  };
  const handleEventClick = (event) => {
    // var date = calendar.getDate();
    // e.toString()
    setAnchorEl(event);
    console.log('event.event', event.event._instance.range.start.toString());
    // Wed Jun 01 2022 14:15:00 GMT+0530 (India Standard Time)
    let utcTime = '2022-06-01 14:15:00';

    // var local_date= moment.utc(utcTime).local().format('YYYY-MM-DD HH:mm:ss');

    console.log('local-------------', moment.utc(utcTime).local()); // 2015-09-13 09:39:27
    let localTimeStart = event.event._instance.range.start;
    setCourseName(event.event._def.extendedProps.courseName);
    setSessionName(event.event._def.extendedProps.sessionName);
    setFacultyName(event.event._def.extendedProps?.FacultyBooking?.facultyName);
    setFacilityName(event.event._def.extendedProps.facultyName);
    setStartTime(event.event._def.extendedProps.startTimes);
    setEndTime(event.event._def.extendedProps.endTimes);
  };
  return (
    <Box>
      <FullCalendar
        timeZone="local"
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'timeGridWeek,timeGridDay',
        }}
        // locale={esLocale}
        allDaySlot={true}
        selectLongPressDelay={1}
        longPressDelay={1}
        eventLongPressDelay={1}
        // hoverLongPressDelay={1}
        initialView="timeGridWeek"
        editable={true} // False for stop resize
        selectable={true} // false for stop click the event
        // selectMirror={true}
        dayMaxEvents={true}
        weekends={state.weekendsVisible}
        events={eventData} // alternatively, use the `events` setting to fetch from a feed
        eventClick={handleEventClick}
        eventTimeFormat={{
          hour: 'numeric',
          minute: '2-digit',
          // meridiem: false,
        }}
        dateClick={function (arg) {
          console.log('arrrrrrrrrrrrrr', arg.date.toString()); // use *local* methods on the native Date Object
          // will output something like 'Sat Sep 01 2018 00:00:00 GMT-XX:XX (Eastern Daylight Time)'
        }}

        // eventsSet={handleEvents} // called after events are initialized/added/changed/removed
        /* you can update a remote database when these fire:
          eventAdd={function(){}}
          eventChange={function(){}}
          eventRemove={function(){}}  
          */
      />
      {/* View Pop reference */}
      <KenPopover
        disableScrollLock={true}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
      >
        <Box className={classes.popover}>
          <div style={{ display: 'flex', padding: '10px' }}>
            {/* <SiCoursera
              color="##272727"
              size={20}
              // style={{ paddingRight: '10px' }}
            /> */}
            <div style={{ marginLeft: '39px', fontSize: '13px' }}>
              {courseName} - {sessionName}
            </div>
          </div>
          <div style={{ display: 'flex', padding: '10px' }}>
            <AiOutlineClockCircle
              color="##272727 "
              size={20}
              // style={{ paddingRight: '10px' }}
            />
            <div style={{ marginLeft: '20px', fontSize: '13px' }}>
              {changeDateFormat(startTime)} - {changeDateFormat(endTime)}
            </div>
          </div>
          <div style={{ display: 'flex', padding: '10px' }}>
            <GiTeacher
              color="##272727 "
              size={20}
              // style={{ paddingRight: '10px' }}
            />
            <div style={{ marginLeft: '20px', fontSize: '13px' }}>
              {facultyName ? facultyName : 'N/A'}
            </div>
          </div>
          <div style={{ display: 'flex', padding: '10px' }}>
            <FaChalkboardTeacher
              color="##272727 "
              size={20}
              // style={{ paddingRight: '10px' }}
            />
            <div style={{ marginLeft: '20px', fontSize: '13px' }}>
              {faciltyName ? faciltyName : 'N/A'}
            </div>
          </div>
        </Box>
      </KenPopover>
    </Box>
  );
};

export default TimeTableNew;
